<div
    role="group"
    class="agpr-formField agpr-dividerStyleField"
    [ngClass]="{ 'agpr-dividerStyleField-container': field.isPrimary }"
>
    <div [ngClass]="{ 'agpr-formField-heading': field.isPrimary }">
        <span class="agpr-formField-headingLabel">
            {{ field.label | localize }}
        </span>
        @if (field.isPrimary) {
            <div class="agpr-formField-headingButtons">
                @if(field.allowExpertMode) {
                    <agpr-button
                        class="agpr-formField-headingButton"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-code"
                        tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                        tooltipPosition="top"
                        (click)="saveExpertTemplate()"
                    ></agpr-button>
                }
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-floppy-disk"
                    tooltip="PageBuilder.formField.tooltip.saveStyle"
                    tooltipPosition="top"
                    (click)="saveStyle()"
                ></agpr-button>
            </div>
        }
    </div>

    @if (field.showStyleState) {
        <div class="agpr-dividerStyleField-styleState">
            <div class="agpr-inputGroupRow">
                <div class="agpr-inputGroupRow-dropdown">
                    <agpr-dropdown-field
                        [id]="id + '.styleStateDropdown'"
                        [value]="value.displayStyleState"
                        [field]="styleStateField"
                        (changes)="setStyle($event, styleStateField.property)"
                    ></agpr-dropdown-field>
                </div>
                <div class="agpr-inputGroupRow-buttons">
                    <agpr-button
                        icon="fa-regular fa-duotone fa-gear"
                        [id]="id + '.manageStyles'"
                        [style]="buttonTypes.block"
                        tooltip="PageBuilder.formField.tooltip.manageStyles"
                        tooltipPosition="top"
                        (click)="manageStylesButtonClicked()"
                    ></agpr-button>
                </div>
            </div>
        </div>
    }

    @if (!value.template) {
        <div
            class="agpr-dividerStyleField"
            [ngClass]="{
                'agpr-dividerStyleField-content': field.isPrimary,
                'agpr-dividerStyleField-subContent': !field.isPrimary
            }"
        >
            <div class="agpr-dividerStyleField-fieldRow agpr-dividerStyleField-fieldRow-block">
                <agpr-number-input
                    [id]="id + '_heightNumberInput'"
                    [label]="'PageBuilder.formField.heightLabel'"
                    [min]="1"
                    [max]="100"
                    unit="px"
                    [integerOnly]="true"
                    [ngModel]="value.height"
                    (ngModelChange)="setStyle($event, 'height')"
                ></agpr-number-input>
            </div>
            <div class="agpr-dividerStyleField-fieldRow">
                <div class="agpr-dividerStyleField-fieldRow-item">
                     <agpr-color-picker-field
                        class="agpr-dividerStyleField-fontColor"
                        [id]="id + '.dividerColorPicker'"
                        [field]="dividerColorField"
                        [value]="value.dividerColor"
                        (changes)="setStyle($event, dividerColorField.property)"
                    ></agpr-color-picker-field>
                </div>
                <div class="agpr-dividerStyleField-fieldRow-item">
                    <agpr-color-picker-field
                        class="agpr-dividerStyleField-fontColor"
                        [id]="id + '.backgroundColorPicker'"
                        [field]="backgroundColorField"
                        [value]="value.backgroundColor"
                        (changes)="setStyle($event, backgroundColorField.property)"
                    ></agpr-color-picker-field>
                </div>
            </div>
        </div>

        <agpr-block-padding
            class="agpr-dividerStyleField-blockPadding"
            [id]="id + '_padding'"
            *ngIf="!value.template"
            [padding]="value.padding"
            [headerLabelHeading]="true"
            (paddingChanged)="setStyle($event, 'padding')"
        ></agpr-block-padding>
    } @else {
        <div class="agpr-dividerStyleField-styleState">
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ "PageBuilder.styles.expertStyleAppliedPreMessage" | localize }}
                <span style="font-weight: bold">
                    {{ field.label | localize }}
                </span>
                {{ "PageBuilder.styles.expertStyleAppliedPostMessage" | localize }}
            </agpr-message>
        </div>
    }
</div>
